// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InsuranceCoverageForm from '../InsuranceCoverageForm';
import { payersRequested } from 'shared/actions/PayersActions';
import LoadingContent from 'shared/components/LoadingContent';
import { connect } from 'react-redux';
import styles from './InsuranceCoverageForms.module.scss';

class InsuranceCoverageForms extends Component {
  componentDidMount() {
    this.props.dispatch(payersRequested());
    if (this.props.fields.length === 0) {
      this.props.fields.push({ unlistedPayer: false });
    }
  }

  render() {
    const { fields, form, payers } = this.props;
    if (payers.length === 0) return <LoadingContent />;
    return (
      <section className={styles.patient_insurance}>
        {fields.map((coverage, index) => (
          <InsuranceCoverageForm
            key={index}
            coverage={coverage}
            index={index}
            remove={() => fields.remove(index)}
            form={form}
          />
        ))}
        <div className={styles.actions}>
          <button
            type="button"
            className="btn btn-mini"
            onClick={() => fields.push({ unlistedPayer: false })}
          >
            Add More Insurance
          </button>
        </div>
      </section>
    );
  }
}

InsuranceCoverageForms.propTypes = {
  fields: PropTypes.object,
  form: PropTypes.string,
  payers: PropTypes.array,
};

const mapStateToProps = state => ({
  payers: state.payers.items,
});

export default connect(mapStateToProps)(InsuranceCoverageForms);
